module.exports = __webpack_public_path__ + "img/nobj.png";